(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["westline-tire-finder"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-westline-tire-finder]').forEach((finder) => {
    const form = finder.querySelector('form');
    const query = finder.querySelector('[data-westline-query]');
    const error = finder.querySelector('[data-westline-error]');
    const currentSize = new URLSearchParams(window.location.search).get('q');
    const sizeMatch = currentSize ? currentSize.match(/(\d{3})\/(\d{2})R(\d{2})/i) : null;

    if (sizeMatch) {
      finder.querySelector('[data-westline-width]').value = sizeMatch[1];
      finder.querySelector('[data-westline-ratio]').value = sizeMatch[2];
      finder.querySelector('[data-westline-rim]').value = sizeMatch[3];
    }

    form.addEventListener('submit', (event) => {
      const width = finder.querySelector('[data-westline-width]').value.trim();
      const ratio = finder.querySelector('[data-westline-ratio]').value.trim();
      const rim = finder.querySelector('[data-westline-rim]').value.trim();

      if (!width || !ratio || !rim) {
        event.preventDefault();
        error.hidden = false;
        return;
      }

      query.value = width + '/' + ratio + 'R' + rim;
      error.hidden = true;
    });
  });

  } catch(e) { console.error(e); }
})();
})();
